module.exports = __webpack_public_path__ + "static/media/vilacavamobile.f0a075b0.png";